import { Flex, Input } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { QuestionsList } from '../questions-list'
import { FormItem } from '../../../components/form-item'
import { FormSection } from '../../../components/form-section'
import { ClarificationDepthField } from '../clarification-depth-field'
import { CampaignLanguageSettings } from '../campaign-language-settings'
import { InterviewInstructionsField } from '../interview-instructions-field'

export function CampaignInterviewSettingsSection() {
    const { t } = useTranslation()

    return (
        <Flex
            vertical
            gap="large"
        >
            <FormSection title={t('Job posting')}>
                <FormItem
                    name={['data', 'vacancy']}
                    label={t('Job posting contents')}
                >
                    <Input.TextArea autoSize={{ minRows: 5, maxRows: 15 }} />
                </FormItem>
            </FormSection>

            <FormSection title={t('Interview')}>
                <FormItem
                    name={['data', 'questions']}
                    label={t('Questions')}
                >
                    <QuestionsList />
                </FormItem>

                <ClarificationDepthField />

                <InterviewInstructionsField />
            </FormSection>

            <CampaignLanguageSettings interview />
        </Flex>
    )
}
